import { render } from "./FooterNr4.vue?vue&type=template&id=12b25f4e&scoped=true"
import script from "./FooterNr4.vue?vue&type=script&lang=js"
export * from "./FooterNr4.vue?vue&type=script&lang=js"

import "./FooterNr4.vue?vue&type=style&index=0&id=12b25f4e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b25f4e"]])

export default __exports__